import { APIInstance } from "./api.config";

const { api } = new APIInstance({ path: "/v1/auth/" });
let pendingMyProfileRequest = null;

export const AuthenticationService = {
  /**
   * @function login
   * @description Logs in a user with the provided payload.
   * @param {{username: string, password: string}} payload - The payload containing the username and password.
   * @returns {import("./api.types").IResponse<{token: string}>} - A promise that resolves to the login response.
   */
  login: (payload) => {
    return api.post("login", payload, { skipAuth: true });
  },

  /**
   * @function myProfile
   * @description Retrieves the profile of the currently logged-in user.
   * @returns {import("./api.types").IResponse<any>} - A promise that resolves to the profile response.
   */
  myProfile: () => {
    if (!pendingMyProfileRequest) {
      pendingMyProfileRequest = api.get("my-profile").finally(() => {
        pendingMyProfileRequest = null;
      });
    }

    return pendingMyProfileRequest;
  },

  /**
   * @function logout
   * @description Invalidates the session cookie on the server.
   * @returns {Promise}
   */
  logout: () => {
    return api.post("logout");
  },
};
